import { queryCache } from 'react-query';
import { find } from 'lodash/fp';
import { QUERY_KEY_STAFF } from './use-staff';
import { UserStaff } from './staff-types';

export function getStaff() {
  return queryCache.getQueryData<UserStaff[]>(QUERY_KEY_STAFF);
}

export function getUser(userId: string) {
  return find((staffMember) => staffMember.id === userId, getStaff());
}

export function getStaffByAdminType(
  staff: UserStaff[],
  adminType: keyof UserStaff['adminTypes'],
) {
  return staff.filter((staffMember) => staffMember.adminTypes[adminType]);
}

export function getInternalManagers(staff: UserStaff[]) {
  return getStaffByAdminType(staff, 'internalManager');
}
